import React from 'react';
import { Stethoscope, Laptop, TrendingUp, Award } from 'lucide-react';
import ScrollReveal from './ScrollReveal'; // <--- IMPORTA AQUI

export default function Features() {
  const features = [
    {
      icon: <Stethoscope size={32} />,
      title: "Prática desde o 1º Módulo",
      desc: "Não espere se formar para tocar no paciente. Nossos laboratórios simulam a realidade hospitalar."
    },
    {
      icon: <Laptop size={32} />,
      title: "Tecnologia de Ponta",
      desc: "Plataforma de estudos digital e manequins de simulação realística para treinamento."
    },
    {
      icon: <TrendingUp size={32} />,
      title: "Alta Empregabilidade",
      desc: "Parcerias exclusivas com hospitais da região para encaminhamento direto ao estágio."
    },
    {
      icon: <Award size={32} />,
      title: "Certificação Reconhecida",
      desc: "Diploma válido em todo território nacional com registro garantido no COREN."
    }
  ];

  return (
    <section id="vantagens" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Anima o Título também */}
        <ScrollReveal>
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-conectiva-navy mb-4">
              Por que somos a escolha certa?
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              A Connectiva une tradição no ensino com a inovação que o mercado de saúde exige hoje.
            </p>
          </div>
        </ScrollReveal>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((item, index) => (
            // AQUI O PULO DO GATO: Multiplicamos o delay pelo index.
            // O primeiro card tem delay 0.2, o segundo 0.4, o terceiro 0.6...
            // Isso cria aquele efeito "escadinha" (um subindo depois do outro)
            <ScrollReveal key={index} delay={index * 0.2}> 
              <div className="bg-white p-6 rounded-2xl shadow-lg hover:shadow-xl transition duration-300 border-b-4 border-transparent hover:border-conectiva-lime group h-full">
                <div className="mb-4 text-conectiva-navy group-hover:text-conectiva-lime transition-colors">
                  {item.icon}
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">{item.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}